import script from "./ProfessionalProfilePhotoUploadForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalProfilePhotoUploadForm.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalProfilePhotoUploadForm.vue?vue&type=style&index=0&id=370f437c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370f437c"]])

export default __exports__